var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;
import { handleActions } from "redux-actions";
import { RECEIVED_USER_LOGIN } from "../actions/actionTypes";
var initState = {
    id: null,
};
var userReducer = handleActions((_a = {},
    _a[RECEIVED_USER_LOGIN] = function (state, action) {
        var user = action.payload.user;
        return __assign({}, state, user);
    },
    _a), initState);
export default userReducer;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/reducers/user.ts
// module id = FK8g
// module chunks = 2